<tpm-dialog-frame
  alt-theme
  [closable]="hasCloseButton()"
  [hasSticky]="true"
  [hasFooter]="hasFooter()"
  [hasCloseButton]="hasCloseButton()"
  [header]="'PRIVACY_AND_TERMS_DIALOG.header' | translate"
  [submitButtonLabel]="submitButtonLabel() | translate"
  [submitDisabled]="submitDisabled"
  [formGroup]="form"
  (submitted)="onSubmit()"
>
  <div sticky class="sticky-container">
    <tpm-tabs
      class="tabs"
      variant="primary"
      [active]="activeTab()"
      [tabs]="tabs"
      (activeTabChange)="activeTab.set($any($event))"
    ></tpm-tabs>
  </div>
  <div class="inner-html-content" [innerHTML]="content() | translate"></div>
  <ng-container *ngIf="activeTab() === 'approval'">
    <div *ngFor="let checkbox of policyCheckboxes" class="checkbox-container">
      <tpm-checkbox
        alt-theme
        density="small"
        [formControlName]="checkbox"
        [label]="getCheckboxLabel(checkbox) | translate"
      ></tpm-checkbox>
      <a class="text-link-sm link" (click)="activeTab.set(policyLinks[checkbox].link)">
        {{ policyLinks[checkbox].label | translate }}
      </a>
    </div>
  </ng-container>
  <div formGroupName="cookiesDetails" *ngIf="activeTab() === 'cookies'">
    <div *ngFor="let checkbox of cookiesDetailsCheckboxes" class="checkbox-container">
      <tpm-checkbox alt-theme density="small" [formControlName]="checkbox.name"></tpm-checkbox>
      <span class="body-sm" [innerHTML]="checkbox.label | translate"></span>
    </div>
  </div>
</tpm-dialog-frame>
